import React from "react";
import TextInputField from '../../../../helpers/TextInputField';
import DropDownField from '../../../../helpers/DropDownField';
import TextAreaField from "../../../../helpers/TextAreaField";
import Button from "../../../../helpers/Button";

const EditUom = () => {
    return(
        <div className="p-card">
            <h5>Edit UOM</h5>
            <div className="grid">
                
                <div className="flex flex-column col-12 mb-2 lg:col-4 lg:mb-0">
                    <TextInputField name="uomName" labelText="UOM Name"  />
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-4 lg:mb-0">
                    <TextInputField name="uomValue" labelText="UOM Value"  />
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-4 lg:mb-0" style={{height:"69px"}}>
                    <TextAreaField name="uomDescription" labelText="UOM Description"  />
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-4 lg:mb-0">
                    <DropDownField name="country" labelText="select Country"  />
                </div>
            </div>
            <div className='mt-3 flex justify-content-end'>
                <Button label="Edit UOM"/>
            </div>
               
        </div>
    )
}
export default EditUom;